export const LEAVE_STATUS_META = {
  draft: { label: "Draft", cls: "text-slate-600 border-slate-300" },
  pending: { label: "Pending", cls: "text-amber-700 border-amber-300 bg-amber-50" },
  approved: { label: "Approved", cls: "text-emerald-700 border-emerald-300 bg-emerald-50" },
  rejected: { label: "Rejected", cls: "text-rose-700 border-rose-300 bg-rose-50" },
  cancel_requested: { label: "Cancel Requested", cls: "text-violet-700 border-violet-300 bg-violet-50" },
  cancelled: { label: "Cancelled", cls: "text-slate-500 border-slate-300" },
};

export const statusMeta = (s) => LEAVE_STATUS_META[s] || { label: s || "—", cls: "text-slate-600 border-slate-300" };

export const REF_TYPE_META = {
  opening: { label: "Opening Balance", cls: "text-sky-700 border-sky-300" },
  application: { label: "Approved Leave", cls: "text-rose-700 border-rose-300" },
  cancellation: { label: "Cancellation", cls: "text-emerald-700 border-emerald-300" },
  adjustment: { label: "Manual Adjustment", cls: "text-violet-700 border-violet-300" },
};

export const fmtDate = (s) => (s ? String(s).slice(0, 10) : "—");
export const todayISO = () => new Date().toISOString().slice(0, 10);
export const addDays = (iso, n) => {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};
export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const CURRENT_YEAR = new Date().getFullYear();
export const YEAR_OPTIONS = Array.from({ length: 6 }, (_, i) => CURRENT_YEAR - i);

export const fmtDays = (n) => {
  const v = Number(n || 0);
  return Number.isInteger(v) ? String(v) : v.toFixed(1);
};
